import { useEvent } from '../eventHooks';

const EMPTY_SETTINGS = Object.freeze({});

/**
 * Returns the settings of an event.
 *
 * @param {number} eventId - The ID of the event.
 * @return {object} The settings object of the event.
 */
export function useEventSettings(eventId) {
    const event = useEvent(eventId);
    return event?.settings ?? EMPTY_SETTINGS;
}
